import type { ApprovalRequest } from '@/lib/types';
import { BucketShell } from './_BucketShell';
import { readDefaultFields, readStructuredFields } from './_payload';

export function ParseErrorView({ req }: { req: ApprovalRequest }) {
  const defaults = readDefaultFields(req);
  const structured = readStructuredFields(req);
  const message =
    typeof structured['error_message'] === 'string' && structured['error_message'].trim()
      ? structured['error_message'].trim()
      : 'Invoice OCR returned text that could not be parsed into the expected JSON payload.';
  const failedNode =
    typeof structured['failed_node'] === 'string' && structured['failed_node'].trim()
      ? structured['failed_node'].trim()
      : 'OCR parse';
  const rawText =
    typeof structured['raw_text'] === 'string'
      ? structured['raw_text']
      : typeof defaults.gemini_raw?.raw_text === 'string'
        ? defaults.gemini_raw.raw_text
        : '';

  return (
    <BucketShell req={req}>
      <section className="rounded-lg border border-error-500/30 bg-error-500/10 p-16">
        <p className="text-xs font-semibold uppercase tracking-wide text-error-500">
          Could not read invoice
        </p>
        <p className="mt-4 text-sm text-neutral-800">{message}</p>
        <dl className="mt-12 grid gap-8 text-sm tablet:grid-cols-2">
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-neutral-500">
              Failed step
            </dt>
            <dd className="mt-2 font-mono text-neutral-900">{failedNode}</dd>
          </div>
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-neutral-500">
              Drive file
            </dt>
            <dd className="mt-2 font-mono text-neutral-900">
              {defaults.drive_file_id ?? req.external_ref}
            </dd>
          </div>
        </dl>
        {rawText && (
          <pre className="mt-12 max-h-[260px] overflow-auto whitespace-pre-wrap rounded-md border border-error-500/20 bg-neutral-0 p-12 text-xs text-neutral-800">
            {rawText}
          </pre>
        )}
      </section>
    </BucketShell>
  );
}
